<app-approve-action class="project-action"></app-approve-action>
<app-save-action class="project-action"></app-save-action>
<app-reject-action class="project-action"></app-reject-action>
<app-download-log-action class="project-action"></app-download-log-action>
<app-exit-action class="project-action"></app-exit-action>
